/**
 * @description: 商品免单招待明细报表
 * @author: lyr
*/
<template>
    <div class="goodsfree-detail-report">
        <div class="red-tip">注：1 历史数据支持跨两个月内查询。2 该表不显示多收款方式下的账单的免单招待商品数据</div>
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable  placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢区域">
                    <el-input placeholder="请选择包厢区域" v-model="room_area_str" readonly @click.native="openRoomAreaPop"></el-input>
                </el-form-item>
                <el-form-item label="包厢号">
                    <el-select v-model="list_form.room_id" filterable clearable placeholder="请选择包厢" :disabled="list_form.shop_id==''">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预订人">
                    <el-input placeholder="请输入预订人姓名" v-model="list_form.book_admin_name"></el-input>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-input placeholder="请选择商品类型" v-model="goods_type_str" readonly @click.native="openGoodsTypePop"></el-input>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="list_form.goods_name" clearable placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="操作人">
                    <el-input placeholder="请输入操作人姓名" v-model="list_form.admin_name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <div class="total-row">
                <div class="item">合计金额：{{actual_pay_total}}</div>
                <div class="item">成本总额合计：{{buying_price_total}}</div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="list_table">
                <el-table-column prop="create_time" label="下单时间" width="160"></el-table-column>
                <el-table-column prop="order_id" label="订单编号" width="160"></el-table-column>
                <el-table-column prop="room_area_name" label="包厢区域"></el-table-column>
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="book_admin_name" label="预定人"></el-table-column>
                <el-table-column prop="bill_no" label="账单号" width="150"></el-table-column>
                <el-table-column prop="admin_name" label="操作人"></el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column prop="goods_name" label="商品名称" width="150"></el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="actual_pay" label="单价"></el-table-column>
                <el-table-column prop="quantity" label="净销售数量"></el-table-column>
                <el-table-column prop="actual_pay_total" label="金额"></el-table-column>
                <el-table-column prop="buying_price" label="成本单价"></el-table-column>
                <el-table-column prop="buying_price_total" label="成本总额"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
        <!-- 包厢区域选择 -->
        <div class="room-area-pop" ref="room_area_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllRoomArea" @change="handleCheckAllRoomAreaChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.area_ids" @change="handleCheckRoomAreaChange">
                    <el-checkbox v-for="item in room_area_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 商品类型选择 -->
        <div class="goods-type-pop" ref="goods_type_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllGoodsType" @change="handleCheckAllGoodsTypeChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.goods_type" @change="handleCheckGoodsTypeChange">
                    <el-checkbox v-for="item in goods_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'goodsfree-detail-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_area_list: [],
                room_list: [],
                goods_type_list: [],
                checkAllRoomArea: false,
                checkAllGoodsType: false,
                list_form: {
                    start_date: '',
                    end_date: '',
                    shop_id: '',
                    area_ids: [],
                    room_id: '0',
                    book_admin_name: '',
                    goods_type: [],
                    goods_name: '',
                    admin_name: '',
                },
                list_table: [],
                list_page: 1,
                list_total: 0,
                actual_pay_total: 0, // 合计金额
                buying_price_total: 0, // 成本总额合计
            }
        },
        computed: {
            room_area_str() {
                if (this.list_form.area_ids.length == 0) {
                    return ''
                }else if(this.list_form.area_ids.length == this.room_area_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.area_ids.forEach(v => {
                        this.room_area_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },

            goods_type_str() {
                if (this.list_form.goods_type.length == 0) {
                    return ''
                }else if(this.list_form.goods_type.length == this.goods_type_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.goods_type.forEach(v => {
                        this.goods_type_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_date = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_date = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getRoomArea(this.list_form.shop_id)
                this.getRoom(this.list_form.shop_id)
                this.getGoodsType()
                this.setShopDefaultTime(this.shop_list[0].id)
                this.getList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_date = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 61
                    }
                }, function(start, end, label) {
                    _this.list_form.start_date = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_date = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getRoomArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_area_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getAllRoom', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_list = res.data.response.result;
                        _this.room_list.unshift({
                            id: '0',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
           
            getList(page) {
                const _this = this;

                _this.loading = true;
                Vue.axios.post('report/getFreeGoodsList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_date,
                            "end_date": _this.list_form.end_date,
                            "shop_id": _this.list_form.shop_id,
                            "area_ids": _this.list_form.area_ids,
                            "room_id": _this.list_form.room_id,
                            "book_admin_name": _this.list_form.book_admin_name,
                            "goods_type": _this.list_form.goods_type,
                            "goods_name": _this.list_form.goods_name,
                            "admin_name": _this.list_form.admin_name
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.list_total = Number(res.data.response.result.total)
                            _this.actual_pay_total = res.data.response.result.actual_pay_total
                            _this.buying_price_total = res.data.response.result.buying_price_total
                        }
                        _this.list_table = res.data.response.result.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            changeShop(val) {
                this.list_form.shop_id = val
                if (!!val) {
                    this.list_form.area_ids = []
                    this.list_form.room_id = '0'
                 
                    this.getRoomArea(val)
                    this.getRoom(val)
                    this.setShopDefaultTime(val)
                }
            },

            // 打开包厢区域选择弹窗
            openRoomAreaPop() {
                let _this = this
                let c_area_ids = _this.list_form.area_ids
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择包厢区域', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.room_area_pop),
                    cancel: function() {
                        _this.list_form.area_ids = c_area_ids
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.area_ids = c_area_ids
                    layer.closeAll()
                });
            },

            // 包厢区域全选
            handleCheckAllRoomAreaChange(val) {
                this.list_form.area_ids = []
                this.checkAllRoomArea = val
                if (val) {
                    this.room_area_list.forEach(item => {
                        this.list_form.area_ids.push(item.id)
                    })
                }
            },

            // 选择包厢区域
            handleCheckRoomAreaChange(val) {
                this.checkAllRoomArea = val.length === this.room_area_list.length
            },

            // 打开商品类型选择弹窗
            openGoodsTypePop() {
                let _this = this
                let c_goods_type = _this.list_form.goods_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择商品类型', true],
                    area: ['550px', ''], // 宽高
                    content: $(_this.$refs.goods_type_pop),
                    cancel: function() {
                        _this.list_form.goods_type = c_goods_type
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.goods_type = c_goods_type
                    layer.closeAll()
                });
            },

            // 商品类型全选
            handleCheckAllGoodsTypeChange(val) {
                this.list_form.goods_type = []
                this.checkAllGoodsType = val
                if (val) {
                    this.goods_type_list.forEach(item => {
                        this.list_form.goods_type.push(item.id)
                    })
                }
            },

            // 选择商品类型
            handleCheckGoodsTypeChange(val) {
                this.checkAllGoodsType = val.length === this.goods_type_list.length
            },

            // 查询
            listQuery() {
                this.list_page = 1
                this.getList(this.list_page);
            },
            
            listExport: function() {
                window.location.href = Vue.ctUrl + "report/freeGoodsExport" +
                    "?start_date=" + this.list_form.start_date +
                    "&end_date=" + this.list_form.end_date +
                    "&shop_id=" + this.list_form.shop_id +
                    "&area_ids=" + this.list_form.area_ids +
                    "&room_id=" + this.list_form.room_id +
                    "&book_admin_name=" + this.list_form.book_admin_name +
                    "&goods_type=" + this.list_form.goods_type +
                    "&goods_name=" + this.list_form.goods_name + 
                    "&admin_name=" + this.list_form.admin_name;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .red-tip {
        color: red;
        margin-bottom: 10px;
    }

    .total-row {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item {
            margin-right: 50px;
        }
    }

    .room-area-pop,
    .goods-type-pop {
        display: none;
        .el-checkbox {
            width: 150px;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }
</style>